import { PublicConfig } from '../../models/environment.public';
import { commonEnvVars, devEnv } from 'src/common/environments/environment.public.common';

const config: PublicConfig = {
    appId: 'l7xx4acddd5d4e47424b9d57330e14984c94',
    appziSrc: `https://w.appzi.io/w.js?token=ddwHY`,
    brand: 'Tempstar',
    brandPath: 'icp',
    publicBaseUrl: 'https://dev-tempstar.hvacpartners.com',
    siteCode: 815,
    ...devEnv
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const environment: any = { ...commonEnvVars(config) };
